

// // src\themes\tolica\components\AdminSupportButton.tsx
// 'use client';

// import { useState } from 'react';
// import { Headset, X, Phone, MessageCircle } from 'lucide-react';

// interface SupportWidgetProps {
//     active?: boolean;
// }

// export default function SupportWidget({ active = true }: SupportWidgetProps) {
//     const [isOpen, setIsOpen] = useState(false);
//     const [showMenu, setShowMenu] = useState(false);

//     if (!active) return null;

//     const chatUrl = "https://club.xoos.ir/fa/club/support?widget=true";
//     // const chatUrl = "http://localhost:3001/fa/club/support?widget=true";
//     const phoneNumber = "09120337430";

//     const handleMainButtonClick = () => {
//         if (isOpen) {
//             setIsOpen(false);
//         } else {
//             setShowMenu((prev) => !prev);
//         }
//     };

//     return (
//         <div className="fixed bottom-6 right-6 z-[9999] flex flex-col items-end gap-3">

//             {isOpen && (
//                 <div className="mb-0 w-[360px] h-[550px] sm:h-[600px] bg-white rounded-xl shadow-2xl overflow-hidden border border-gray-200 transition-all duration-300 origin-bottom-right flex flex-col">
//                     <div className="bg-black text-white p-4 flex justify-between items-center shadow-md z-10">
//                         <div className="flex flex-col">
//                             <h3 className="font-bold text-md">پشتیبانی آنلاین</h3>
//                             <span className="text-xs opacity-80">پاسخگوی سوالات شما هستیم</span>
//                         </div>
//                         <button onClick={() => setIsOpen(false)} className="hover:bg-white/20 p-1.5 rounded-lg transition-colors">
//                             <X size={20} />
//                         </button>
//                     </div>

//                     <iframe
//                         src={chatUrl}
//                         className="w-full flex-1 border-none bg-gray-50"
//                         title="پشتیبانی"
//                     />
//                 </div>
//             )}

//             {/* منوی انتخاب راه ارتباطی */}
//             {showMenu && !isOpen && (
//                 <div className="flex flex-col gap-2 bg-white rounded-xl shadow-2xl border border-gray-200 p-2 min-w-[200px] animate-in fade-in slide-in-from-bottom-2 duration-200">
//                     <button
//                         onClick={() => {
//                             setIsOpen(true);
//                             setShowMenu(false);
//                         }}
//                         className="flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-gray-100 transition-colors text-right"
//                     >
//                         <MessageCircle className="w-5 h-5 text-black shrink-0" />
//                         <span className="text-sm font-medium text-gray-800">چت آنلاین</span>
//                     </button>

//                     <a
//                         href={`tel:${phoneNumber}`}
//                         className="flex items-center gap-3 px-3 py-2.5 rounded-lg hover:bg-gray-100 transition-colors text-right"
//                     >
//                         <Phone className="w-5 h-5 text-black shrink-0" />
//                         <div className="flex flex-col">
//                             <span className="text-sm font-medium text-gray-800">تماس تلفنی</span>
//                             <span dir="ltr" className="text-xs text-gray-500">{phoneNumber}</span>
//                         </div>
//                     </a>
//                 </div>
//             )}

//             {!isOpen && (
//                 <button
//                     onClick={handleMainButtonClick}
//                     className="flex items-center justify-center w-14 h-14 bg-black text-white rounded-full shadow-xl hover:scale-110 hover:shadow-2xl transition-all duration-300"
//                     aria-label="پشتیبانی"
//                 >
//                     {showMenu ? <X className="w-7 h-7" /> : <Headset className="w-7 h-7" />}
//                 </button>
//             )}
//         </div>
//     );
// }